const TOGGLE_KANA_SWITCH = "TOGGLE_KANA_SWITCH";

export { TOGGLE_KANA_SWITCH };